<template>
  <div v-if="this.riseupGoal >= 0" class="riseupGoal card-box container-padding">
    <div class="container-padding">
      <div class="header">
        <div class="goal">יעד riseup</div>
        <img class="edit" v-on:click.stop="openSectionMenu"
             :src="require('@/assets/icons/menu.svg')">
      </div>
      <div class="title">
        <div>כמה כסף ישאר בסוף {{this.monthName}}?</div>
      </div>
      <div class="value">
        {{this.formattedRiseupGoal}} ₪
      </div>
      <div class="disclaimer">
        <img class="notice-icon" :src="require('@/assets/icons/exclemation-mark-yellow.svg')">
        <span v-if="hasRemainingVariables">אם תעמדו ביעד ההוצאות המשתנות</span>
        <span v-else>אם לא תוציאו עוד הוצאות משתנות</span>
      </div>
    </div>
    <riseup-goal-section-menu v-if="showSectionMenu"
                            :closeMenu="() => this.showSectionMenu = false"/>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import Segment from '../../../../../../../../Segment';
import moneyUtils from '../../../../../../../../utils/money';
import RiseupGoalSectionMenu from './cashflow-edit/edit-riseup-goal/RiseupGoalSectionMenu.vue';

export default {
  name: 'RiseupGoal',
  components: {
    RiseupGoalSectionMenu,
  },
  data() {
    return {
      showSectionMenu: false,
    };
  },
  computed: {
    ...mapGetters('cashflowView', ['monthName', 'riseupGoal', 'remainingVariables']),
    formattedRiseupGoal() {
      return moneyUtils.formatAmountWithFraction(this.riseupGoal, 0);
    },
    hasRemainingVariables() {
      return this.remainingVariables > 0;
    },
  },
  methods: {
    openSectionMenu() {
      Segment.trackUserInteraction('OpenSectionMenuClicked', {
        expenseCategory: 'riseup-goal',
      });
      this.showSectionMenu = true;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  .riseupGoal {
    margin-bottom: 16px;
    position: relative;

    .container-padding {
      padding: 18px;
    }

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .goal {
        color: $riseup_yellow;
        font-size: 10px;
        font-weight: bold;
      }

      .edit {
        height: 16px;
        cursor: pointer;
        margin-bottom: 10px;
      }
    }

    .title {
      font-family: GretaSans;
      font-size: 24px;
      font-weight: bold;
      margin: 4px 0 22px;
    }

    .value {
      font-family: SimplerPro;
      font-size: 46px;
      line-height: 32px;
      margin: 0 0 18px;
      color: $riseup_yellow;
    }

    .disclaimer {
      font-size: 16px;

      .notice-icon {
        width: 12px;
        height: 12px;
        vertical-align: middle;
      }
    }
  }
</style>
